import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { createMergeReducer } from '../utils/reducer'

export type TapsExperimentToken = {
  pvCinemaToken?: PvCinemaToken
} | undefined

export type PvCinemaToken = {
    message: WpsRuntime.atv.wps.DVString,
    logoUrl: string
} | undefined

export type TitleIdToTapsExperimentToken = {
  [titleId: string]: TapsExperimentToken | undefined
}

export const reducer = createMergeReducer(
  t => t.tapsExperimentToken,
  {} as TitleIdToTapsExperimentToken
)